import React from "react";
import TickIcon from "../../../assets/icons/ABHA-icons/tick-icon";
import DownloadIcon from "../../../assets/icons/ABHA-icons/download-icon";
import ShareIcon from "../../../assets/icons/ABHA-icons/share-icon";
import PrintIcon from "../../../assets/icons/ABHA-icons/print-icon";
import EmailIcon from "../../../assets/icons/ABHA-icons/email-icon";
import HealthInsuranceIcon from "../../../assets/icons/admin-customer-icons/health-insurance-icon";
import HealthIcon from "../../../assets/icons/ABHA-icons/health-icon";
import QR from "../../../assets/images/abha-imgs/QR.png";
import InfoIcon from "../../../assets/icons/ABHA-icons/info-icon";
import BulbIcon from "../../../assets/icons/ABHA-icons/bulb-icon";
import AddButton from "../../buttons/button";
import TickIcon2 from "../../../assets/icons/ABHA-icons/tick2-icon";
import CopyIcon from "../../../assets/icons/ABHA-icons/copy-icon";
import InfoIcon2 from "../../../assets/icons/ABHA-icons/info-icon2";
import SandTimeIcon from "../../../assets/icons/ABHA-icons/sand-time-icon";

function DrivingConfirmation({
  closeModal,
  setStatus,
  drivingSuccessData,
  setPosition,
}) {
  const genderText = (data) => {
    if (data === "M") return "Male";
    else if (data === "F") return "Female";
    else return "Transgender";
  };
  return (
    <div className=" flex flex-col mt-8">
      <div className="h-full flex-1  flex  flex-col gap-11 items-center justify-start">
        <div className="flex-1 w-full border flex flex-col bg-[var(--abha-card2-fg)] border-[var(--customer-consol-border-color)] rounded-lg  gap-[10px] p-5">
          <div className=" flex flex-row gap-[10px]">
            <TickIcon2 />
            {console.log("sssssssssssssssssssssssssssssss", drivingSuccessData)}
            <label
              className={`text-[var(--success-color)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-fw)] whitespace-nowrap `}
            >
              Enrolment number is successfully generated.
            </label>
          </div>
        </div>
        <div className=" flex flex-col justify-center items-center gap-4 w-full text-center">
          <label
            className={`
                 text-[length:var(--abha-method-title-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
          >
            Enrolment Details
          </label>
          <label
            className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
          >
            Your enrolment is submitted and awaiting final verification.
          </label>
        </div>
        <div className=" flex flex-col justify-center items-center gap-4 w-full text-center">
          <label
            className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-fw)] whitespace-nowrap`}
          >
            Your Enrolment Number
          </label>
          <div>
            <span className="flex flex-row gap-2 items-center cursor-pointer">
              <label
                className={`text-[var(--primary)]
                 text-[length:var(--abha-method-title2-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
              >
                {drivingSuccessData?.enrolmentNumber}
              </label>
              <CopyIcon />
            </span>
          </div>
        </div>
        <div className="flex-1 w-full  flex flex-col bg-[var(--abha-info-bg)]  rounded-lg  gap-[10px] p-5">
          <div className=" flex flex-row gap-[10px]">
            <InfoIcon2 />
            <label
              className={`text-[var(--abha-info-fs)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-fw)] `}
            >
              Next Steps: Please complete your registration at the nearest
              facility/center to obtain your ABHA number. Please do not forget
              to carry your document and Enrolment number to an ABHA
              participating facility.
            </label>
          </div>
        </div>
        <div className="flex flex-col w-full gap-6">
          {/*options boxes*/}

          {/*info boxes*/}
          <div className="flex-1 w-full border border-dashed flex flex-col bg-[var(--abha-card3-bg)] border-[var(--abha-card3-border-color)] rounded-lg  gap-[10px] p-8">
            <div className=" flex flex-col items-center justify-center gap-[10px]">
              <SandTimeIcon />
              <div className=" flex flex-col justify-center items-center gap-4 w-full text-center">
                <label
                  className={`text-[var(--abha-card3-fg)]
                 text-[length:var(--abha-method-sub-title-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
                >
                  ABHA number will be available after physical verification
                </label>

                <label
                  className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
                >
                  Your details are pending verification at the facility.
                </label>
              </div>
            </div>
          </div>
          {/* last section*/}

          <div className="flex-1 w-full border flex flex-col  border-[var(--abha-nav-bg)] rounded-lg  gap-[10px] p-8">
            <h2 className=" text-[length:var(--abha-method-card-title-fs)] font-[var(--abha-method-card-title-fw)]  mb-6">
              Applicant Information
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* Enrolment Number */}
              <div className="flex flex-col gap-2">
                <label
                  className="text-[var(--abha-nav-fg)]
                text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)]"
                >
                  Enrolment Number
                </label>
                <div className="text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-title-fw)]">
                  {/* 91-7355-0013-7725 */}
                  {drivingSuccessData?.enrolmentNumber ?? "------"}
                </div>
              </div>

              {/* Name */}
              <div className="flex flex-col gap-2">
                <label
                  className="text-[var(--abha-nav-fg)]
                text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)]"
                >
                  Name
                </label>
                <div className="text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-title-fw)]">
                  <span className="flex flex-row gap-1">
                    {drivingSuccessData?.firstName}
                    {drivingSuccessData?.middleName}{" "}
                    {drivingSuccessData?.lastName}
                  </span>
                </div>
              </div>

              {/* Date of Birth */}
              <div className="flex flex-col gap-2">
                <label
                  className="text-[var(--abha-nav-fg)]
                text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)]"
                >
                  Date of birth
                </label>
                <div className="text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-title-fw)]">
                  {drivingSuccessData?.dob}
                </div>
              </div>

              {/* Gender */}
              <div className="flex flex-col gap-2">
                <label
                  className="text-[var(--abha-nav-fg)]
                text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)]"
                >
                  Gender
                </label>
                <div className="text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-title-fw)]">
                  {genderText(drivingSuccessData?.gender)}
                </div>
              </div>

              {/* State */}
              <div className="flex flex-col gap-2">
                <label
                  className="text-[var(--abha-nav-fg)]
                text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)]"
                >
                  State
                </label>
                <div className="text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-title-fw)]">
                  {drivingSuccessData?.state}
                </div>
              </div>

              {/* Verification Type */}
              <div className="flex flex-col gap-2">
                <label
                  className="text-[var(--abha-nav-fg)]
                text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)]"
                >
                  Verification Type
                </label>
                <div className="text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-title-fw)]">
                  DRIVING LICENCE
                </div>
              </div>

              {/* Verification Status */}
              <div className="flex flex-col gap-2">
                <label
                  className="text-[var(--abha-nav-fg)]
                text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)]"
                >
                  Verification Status
                </label>
                <div className="text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-title-fw)]">
                  {drivingSuccessData?.enrolmentState}
                </div>
              </div>
            </div>

            {/* Address - Full Width */}
            <div className="flex flex-col gap-2 mt-6">
              <label
                className="text-[var(--abha-nav-fg)]
                text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)]"
              >
                Address
              </label>
              <div className="text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-title-fw)]">
                {drivingSuccessData?.address}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          bottom: "0",
        }}
        className="flex flex-row gap-3 w-full justify-end  sticky bg-white py-4 mb-0 mt-auto "
      >
        <AddButton
          prefixIcon={false}
          // ref={submitRef}
          onclkFn={() => closeModal()}
          text={<span>Go To Dashboard</span>}
          className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
          type="button"
        />
      </div>
    </div>
  );
}

export default DrivingConfirmation;
